// extracted by mini-css-extract-plugin
export default {"Logo":"Logo__Logo__26x5h"};